import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertPngToBmp() {
  return <ImageConverterTemplate sourceFormat="PNG" targetFormat="BMP" acceptTypes=".png,image/png" slug="convert-png-to-bmp" gradientColors="from-blue-500 to-indigo-600" accentColor="blue" />;
}
